import {Button, Modal, Spinner} from "@tag/tag-components-react-v4";
import React, {useEffect, useState} from "react";
import styles from './CustomerInfoModal.module.scss'
import EvoDetails from "./EvoDetails";
import DbSizes from "./DbSizes";
import {CustomerDTO} from "../../types/CustomerDTO";
import { ProjectAccents } from "../../../General/config/projectAccents";

function CustomerInfoModal(props: {selectedCustomer: CustomerDTO, handleClose: Function}) {

    const [loading, setLoading] = useState<string|boolean>(false);
    const [evoDetailsVisible, setEvoDetailsVisible] = useState(false);
    const [dbSizesVisible, setDbSizesVisible] = useState(false);
    
    let content;
    if (loading) {
        content = <Spinner full={true} >{loading}</Spinner>;
    }
    else {
        content =
            <Modal
                visible={!!props.selectedCustomer}
                accent={ProjectAccents.CareCompliance}
                heading={props.selectedCustomer?.name}
                primaryButtonProps={{buttonStyle: {'display': 'none'}}}
                onCancelButtonClick={() => {
                    props.handleClose();
                }}
                onClose={() => props.handleClose()}
            >
                <div className={styles.CustomerInfoModalButtonContainer}>
                    <div className={styles.CustomerInfoModalButtonElement}>
                        <Button text={'Evo'} onClick={() => setEvoDetailsVisible(true)}/>
                    </div>
                    <div className={styles.CustomerInfoModalButtonElement}>
                        <Button text={'DB Sizes'} onClick={() => setDbSizesVisible(true)}/>
                    </div>
                </div>
            </Modal>
    }

    return (
        <>
            {content}
            {evoDetailsVisible ?
                <EvoDetails
                    visible={evoDetailsVisible}
                    selectedCustomer={props.selectedCustomer}
                    handleClose={() => setEvoDetailsVisible(false)}
                /> : undefined
            }
            {dbSizesVisible ?
                <DbSizes
                    visible={dbSizesVisible}
                    selectedCustomer={props.selectedCustomer}
                    handleClose={() => setDbSizesVisible(false)}
                /> : undefined
            }
        </>
    )

}

export default CustomerInfoModal;
